import React, { useState, useEffect } from "react";

const API_URL = "https://moody-sloths-tickle.loca.lt/api/v1/rpa/register/"; // 🔹 Replace with your FastAPI endpoint

const App: React.FC = () => {
  const [chatId, setChatId] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    telegramUsername: "",
    sellerUsername: "",
    sellerPassword: "",
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const chatIdFromUrl = params.get("chat_id");
    setChatId(chatIdFromUrl);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    let newErrors: { [key: string]: string } = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phone.trim() || !/^\+?[0-9]{7,15}$/.test(formData.phone))
      newErrors.phone = "Valid phone number is required";
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Valid email is required";
    if (!formData.telegramUsername.trim()) newErrors.telegramUsername = "Telegram username is required";
    if (!formData.sellerUsername.trim()) newErrors.sellerUsername = "Seller platform username is required";
    if (!formData.sellerPassword.trim()) newErrors.sellerPassword = "Seller platform password is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!chatId) {
      alert("Chat ID missing. Please access the form via the Telegram bot.");
      return;
    }

    if (!validateForm()) return;

    const payload = { chat_id: chatId, ...formData };
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        mode: "cors", // ✅ Explicitly allow cross-origin requests
        headers: { 
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        alert("Registration successful!");
      } else {
        alert("Failed to register. Try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-xl font-bold text-center mb-4">Register</h2>

        {chatId ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <h3 className="text-lg font-semibold">User Information</h3>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              className="input-field"
            />
            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number (+123456789)"
              value={formData.phone}
              onChange={handleChange}
              className="input-field"
            />
            {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              className="input-field"
            />
            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}

            <input
              type="text"
              name="telegramUsername"
              placeholder="Telegram Username (@username)"
              value={formData.telegramUsername}
              onChange={handleChange}
              className="input-field"
            />
            {errors.telegramUsername && <p className="text-red-500 text-sm">{errors.telegramUsername}</p>}

            <h3 className="text-lg font-semibold">Seller Platform Credentials</h3>
            <input
              type="text"
              name="sellerUsername"
              placeholder="Seller Platform Username"
              value={formData.sellerUsername}
              onChange={handleChange}
              className="input-field"
            />
            {errors.sellerUsername && <p className="text-red-500 text-sm">{errors.sellerUsername}</p>}

            <input
              type="password"
              name="sellerPassword"
              placeholder="Seller Platform Password"
              value={formData.sellerPassword}
              onChange={handleChange}
              className="input-field"
            />
            {errors.sellerPassword && <p className="text-red-500 text-sm">{errors.sellerPassword}</p>}

            <button type="submit" className="w-full bg-green-500 text-white py-2 rounded-md hover:bg-green-600">
              Register
            </button>
          </form>
        ) : (
          <p className="text-red-500 text-center">Invalid access. Please open this link from Telegram.</p>
        )}
      </div>
    </div>
  );
};

export default App;
